import React, {useEffect, useState, useRef} from 'react';
import PropTypes from 'prop-types';
import TaskItem from './TaskItem';
import { useTaskListStore, TASKLIST_ACTIONS } from "../../Store";
import { ACTIVE_TASK_LS_KEY, getFromLS } from '../../utils/TaskUtils';
import { i18n } from '../../utils/GadgetUtils';
import AlertModal from '../task-header/alertmodal';
import { querySelectorAllDeep } from "query-selector-shadow-dom";
import { isVisible, debounce } from "../../utils/ComponentsUtil";

import styles from "./taskList.module.css";

const UP = "icon-arrow-up_12";
const DOWN = "icon-arrow-down_12";
const activateNewTasksAutomatically = prefs.getString('activateNewTasksAutomatically') === '' ? true : prefs.getBool('activateNewTasksAutomatically');

const TaskList = (props) => {

	const [state, handleActions] = useTaskListStore();
	const [buttonClick, setbuttonClick] = useState(false);
    const [continueWithoutSave, setContinueWithoutSave] = useState(false);
	const [unsavedChanges, setUnsavedChanges] = useState(false);
	const stateSelectedTaskIdRef = useRef(state.selectedTaskId);
	const stateTaskListRef = useRef(state.taskList);

	const taskListDomRef = useRef(null);
	let scrollEventAttchedToTaskList = false;
	const [hasHiddenNewMessages, setNewMessagesState] = useState(false);
	const [scrollIconDirection, setScrollDirection] = useState(DOWN);
	const customEventTarget = useRef();

	const getTask = (taskId) => {
		return state.taskList && state.taskList.find((task) => task.taskId === taskId);
	};

	const saveActiveTaskToLS = (task) => {
		task.makeTaskActiveInLS();
	};

	const handleTaskItemSelect = (e) => {
		console.log(':: tasklist handleTaskItemSelect ', e, stateSelectedTaskIdRef.current);
		if (e.target.taskItemProp.task.taskId === stateSelectedTaskIdRef.current) return;

		if (!e.target.taskItemProp.task.areFieldsPresent) {
			props.setErrorAfterTaskLoad({
				title: i18n.getMsg('gadget.imi.gadgetLoad.task.error'),
				description: i18n.getMsg('gadget.imi.gadgetLoad.task.errorDescription')
			});
		}

		// set unsavedChanges value taken from local storage.
		setUnsavedChanges(window.localStorage.getItem('unsavedChanges'));

    // use the unsavedChanges value from local storage to decide whether an alert should be shown or not.
		var _unsavedChanges = window.localStorage.getItem('unsavedChanges');
		
		customEventTarget.current = e.target;

		if(e.target.taskItemProp.task.taskId === JSON.parse(window.localStorage.getItem(ACTIVE_TASK_LS_KEY))?.taskId)
		{
			e.target.taskItemProp && handleActions({ type: TASKLIST_ACTIONS.SELECT, task: e.target.taskItemProp.task });
			e.target.taskItemProp && saveActiveTaskToLS(e.target.taskItemProp.task);

		} else if(_unsavedChanges === 'false' || continueWithoutSave === true){
            setContinueWithoutSave(false);
			setUnsavedChanges(false);
			window.localStorage.setItem('unsavedChanges', false);
            
            e.target.taskItemProp && handleActions({ type: TASKLIST_ACTIONS.SELECT, task: e.target.taskItemProp.task });
			e.target.taskItemProp && saveActiveTaskToLS(e.target.taskItemProp.task);
        }
        else{
            setbuttonClick(true);
            e.preventDefault();
        }

	};

	useEffect(() => {
        if(unsavedChanges === false || continueWithoutSave === true){
            setContinueWithoutSave(false);
			setUnsavedChanges(false);
			window.localStorage.setItem('unsavedChanges', false);
			if(customEventTarget.current !== undefined){
				const _target = customEventTarget.current;
				const newEvent = new CustomEvent('taskitem-click', { 'target': _target});
				Object.defineProperty(newEvent, 'target', {value: _target, enumerable: true});
				window.dispatchEvent(newEvent);
			}
        }
        else{
            setbuttonClick(true);
        }
    }, [continueWithoutSave])

	useEffect(() => {
		window.addEventListener('taskitem-click', handleTaskItemSelect);
		// initialising shortcut key service
		window.finesse.shortcutkey.ShortcutKeyService.init();
		const shortCutKeysForTaskSelection = [
			{
				'id': 'cisco_imi_next_task_select',
				'componentName': i18n.getMsg('gadget.imi.task.select.next.componentname'),
				'actionName': i18n.getMsg('gadget.imi.task.select.next.action'),
				'modifierKeys': window.finesse.shortcutkey.ShortcutKeyService.CONSTANTS.MODIFIER_KEYS.CTRL_SHIFT,
				'key': i18n.getMsg('gadget.imi.task.select.next.action.key.8'),
				handler: () => {
					const task = stateTaskListRef.current && stateTaskListRef.current.find((task) => task.taskId === stateSelectedTaskIdRef.current);
					let currentTaskIndex = stateTaskListRef.current.indexOf(task);
					// else get id of next element
					if (stateTaskListRef.current.length > 1 && (currentTaskIndex !== stateTaskListRef.current.length - 1)) {
							const newSelectedTask = stateTaskListRef.current.find((task) => task.taskId === stateTaskListRef.current[currentTaskIndex + 1]?.taskId);
							handleActions({ type: TASKLIST_ACTIONS.SELECT, task: newSelectedTask });
							saveActiveTaskToLS(newSelectedTask);
					}
				}
			},
			{
				'id': 'cisco_imi_previous_task_select',
				'componentName': i18n.getMsg('gadget.imi.task.select.previous.componentname'),
				'actionName': i18n.getMsg('gadget.imi.task.select.previous.action'),
				'modifierKeys': window.finesse.shortcutkey.ShortcutKeyService.CONSTANTS.MODIFIER_KEYS.CTRL_SHIFT,
				'key': i18n.getMsg('gadget.imi.task.select.previous.action.key.9'),
				handler: () => {
					const task = stateTaskListRef.current && stateTaskListRef.current.find((task) => task.taskId === stateSelectedTaskIdRef.current);
					let currentTaskIndex = stateTaskListRef.current.indexOf(task);
					// else get id of next element
					if (stateTaskListRef.current.length > 1 && (currentTaskIndex !== 0)) {
							const newSelectedTask = stateTaskListRef.current.find((task) => task.taskId === stateTaskListRef.current[currentTaskIndex - 1]?.taskId);
							handleActions({ type: TASKLIST_ACTIONS.SELECT, task: newSelectedTask });
							saveActiveTaskToLS(newSelectedTask);
					}
				}
			}
		];
		window.finesse.shortcutkey.ShortcutKeyService.registerShortcutKey(shortCutKeysForTaskSelection);
		return () => {
			window.removeEventListener('taskitem-click', handleTaskItemSelect);
		};
	}, []);

	useEffect(() => {
		const activeTask = getFromLS(ACTIVE_TASK_LS_KEY);
		stateSelectedTaskIdRef.current = state.selectedTaskId;
		stateTaskListRef.current = state.taskList;
		console.log(':: tasklist state changed. Updated state is- ', state, activeTask);
		if (!activeTask) {
			const task = getTask(state.selectedTaskId);
			task && saveActiveTaskToLS(task);
		} else if (!activateNewTasksAutomatically && activeTask && (activeTask.taskId !== state.selectedTaskId)) {
			const task = getTask(activeTask.taskId);
			console.log(':: tasklist state changed. making the task active and adding to local storage - ', task);
			if (task) {
				handleActions({ type: TASKLIST_ACTIONS.SELECT, task: task });
				saveActiveTaskToLS(task);
			}
		}
	},[state]);

	/* Returns dom_ref array of new_replies which are not visible */
	const getHiddenNewRepliesRefs = () =>
	querySelectorAllDeep(".new-chat-quantity").filter(
		(ele) => !isVisible(ele, taskListDomRef.current)
	);

	/* new_replies button will be displayed if atleat one new_replies badge is hidden in scroll view */
	const checkForHiddenNewMessages = () => {
		const hiddenNewReplies = getHiddenNewRepliesRefs();
		const firstRef = hiddenNewReplies[0];
		/* based on position of first hidden new_reply badge in the scroll view, arrow direction is determined */
		setScrollDirection(firstRef?.getBoundingClientRect()?.top < 0 ? UP : DOWN);
		setNewMessagesState(hiddenNewReplies?.length > 0);
	};

	/* attach scroll event to tasklist container to recheck new_replies position and update new_replies button */
	useEffect(() => {
		if (!scrollEventAttchedToTaskList) {
			taskListDomRef?.current.addEventListener("scroll",debounce(checkForHiddenNewMessages, 100));
			scrollEventAttchedToTaskList = true;
		}
	}, [taskListDomRef]);

	/* check if new_replies badges are creaded, on each update */
	useEffect(() => {
		setTimeout(checkForHiddenNewMessages, 100); // Added for fresh loading and rerender
	}, [taskListDomRef, props.taskItems]);

	/* scrolls container to make new_replies badge visible */
	const scrollNewReplyToView = () => {
		const newReplyDomRef = getHiddenNewRepliesRefs()[0];
		newReplyDomRef?.scrollIntoView({
			behavior: "smooth",
			block: "center",
			inline: "nearest",
		});
	};

	function getSortedOrderOfTasks (taskList) {
		// sorted tasks based on the timestamp to retain order of the tasks
		const orderedTasks = [...taskList].sort((task1, task2) => task1.timeStamp - task2.timeStamp);
		console.log(':: tasklist getSortedOrderOfTasks. orderedTasks : ', taskList, orderedTasks);
		return orderedTasks;
	}

	return (
		<div ref={taskListDomRef} style={{height: '100%'}}>
			{state.taskList && state.taskList.length > 0 ? getSortedOrderOfTasks(state.taskList).map((task, index) => (
				<TaskItem key={index} task={task} active={state.selectedTaskId && state.selectedTaskId === task.taskId} />
			)) : <div id='taskItem-automation' style={{height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{i18n.getMsg('gadget.imi.taskPane.title.noMessages')}</div>
			}
			{
                buttonClick && <AlertModal unSavedChanges={unsavedChanges} ButtonClick={buttonClick} setButtonClick={setbuttonClick} continueWithoutSave={continueWithoutSave} setContinueWithoutSave={setContinueWithoutSave} /> 
            }
			{
				hasHiddenNewMessages && (
					<md-button
						onClick={scrollNewReplyToView}
						class={styles["new-messages-btn"]}
						variant="primary"
						color="blue"
					>
						{i18n.getMsg("gadget.imi.task.newreplies")} &nbsp;
						<md-icon
							className="arrow-icon"
							name={scrollIconDirection}
						></md-icon>
					</md-button>
				)
			}
		</div>
	);
};

TaskList.propTypes = {
	taskItems: PropTypes.array
};

export default TaskList;
